import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostIssuePersonal = (params, setOpenModal, setStep, setOpenModalErrors, setSelectId) => {
    return async (dispatch, getState) => {
        try {
            const newParams = {
                gamer: params.select_gamer,
                bonus_name: params.bonuses,
                cause: params.cause
            }

            const {data} = await DefaultApi({
                params: newParams,
                method: 'post',
                url: urls.POST_ISSUE_PERSONAL_BONUSES
            });
            if (data.status === 'success') {
                setOpenModal(true);
                setStep(1);
                setSelectId([])
            }
        } catch (error) {
            //todo доделать catch 
            setOpenModalErrors(true)
            getCatchError(error)
        }
    }
}

export {
    setPostIssuePersonal as SetPostIssuePersonal
}